<template>
  <div
    class="radio-button-square-container"
    :style="`
      ${items_per_row
        ? `width: calc((100% - ${(items_per_row - 1) * 8}px) / ${items_per_row});`
        : ''
      }
      ${!items_per_row && width
        ? `width: ${width}px;
          height: ${width}px`
        : ''
      }`"
  >
    <!-- BADGE -->
    <div
      v-if="is_badge"
      class="radio-button-square-badge"
      :style="`
        color:${getColor(foreground_color)};
        background-color:${getColor(background_color)};
        ${badge_width
          ? `height: ${badge_width}px;
            width: ${badge_width}px;
            top: -${badge_width / 4}px;
            right: -${badge_width / 4}px;
            border-radius: ${badge_width / 2}px;`
          : ''
        }`"
    >
      <!-- ACTUAL BADGE -->
      <slot
        name="badge"
      />
    </div>

    <div class="radio-button-square-dummy-height" v-if="items_per_row"/>
    <!-- ACTUAL BUTTON -->
    <button
      v-if="!is_invisible"
      class="radio-button-square-border"
      :disabled="is_disabled"
      :style="`
        ${items_per_row ? 'position: absolute; top: 0px; left: 0px;' : ''}
        border-color: ${getColor(foreground_color)};
        color:${is_active ? `${getColor(background_color)}` : `${getColor(foreground_color)}`};
        fill:${is_active ? `${getColor(background_color)}` : `${getColor(foreground_color)}`};
        opacity:${is_disabled ? '.33' : '1'};
        background-color:${is_active ? `${getColor(foreground_color)}` : ''};
        `"
      v-ripple
      @click="$emit('setActive', id);"
    >
      <!-- ACTUAL CONTENT -->
      <slot
        name="content"
      />
    </button>
  </div>
</template>

<script>
import { TColor } from '@/mixins/TColor.mixin.js';

  export default {
    props: [
      'id', // is string, is unique identifier
      'is_active', // is boolean, toggles display of status
      'is_badge', // is boolean, toggles display of badge
      'is_disabled', // is boolean, toggles display of in-use days
      'is_invisible', // is boolean, turns off placeholder divs
      'width', // is number, sets width dynamically
      'badge_width', // is number, sets alternative badge width
      'background_color', // is string, contains hexadecimal value of background
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
      'items_per_row'
    ],

    mixins: [
      TColor,
    ],

    data: () => ({

    }),
  }
</script>

<style>
  .radio-button-square-container {
    position: relative;
    flex-shrink: 0;
    width: 40px;
  }
  .radio-button-square-border {
    border: 1px solid;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    outline: none;
  }
  .radio-button-square-badge {
    z-index: 1;
    position: absolute;
    border: 1px solid;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 16px;
    width: 16px;
    top: -4px;
    right: -4px;
    border-radius: 8px;
  }
  .radio-button-square-dummy-height {
    padding-top: 100%;
  }
</style>
